import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import {GestioneAnniPrecedentiComponent} from './gestione-anni-precedenti';

let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('home.gestione-anni-precedenti', {
            url: '/gestione-anni-precedenti',
            ncyBreadcrumb: {
                label: 'Gestione Anni Precedenti',
                parent: 'home.admin'
            },
            data: {
                authorisationLevel: 2,
                pageTitle: 'Gestione Anni Precedenti'
            },
            'views': {
                'homeContent': {
                    template: '<gestione-anni-precedenti flex="100"></gestione-anni-precedenti>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const GestioneAnniPrecedentiModule: string = ng
    .module('gestione-anni-precedenti', [
        'ui.bootstrap',
        uiRouter,
    ])
    .component('gestioneAnniPrecedenti', GestioneAnniPrecedentiComponent)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/admin/gestione-anni-precedenti/gestione-anni-precedenti.module.ts